import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Paper, Box, Paragraph, Typography, FormControlLabel, Checkbox, Divider, makeStyles } from '@material-ui/core';

function CardWitTitle({ title, onChange, checked, name, children, ...props }) {

  const useStyles = makeStyles(theme => ({
    header: {
      flexDirection: 'row',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    }
  }));

  const classes = useStyles();

  return (
    <React.Fragment>
      <Paper>
        <Box textAlign='left' p={2} className={classes.header}>
          <Typography variant='h6' component='h2' color='primary'>{title}</Typography>
          {onChange && name &&
            <FormControlLabel
              control={
                <Checkbox
                  name={name}
                  checked={checked}
                  onChange={onChange}
                  color='primary'
                />
              }
              label="Godkänn"
            />
          }
        </Box>

        <Divider />
        <Box p={2}>
          {children}
        </Box>
      </Paper>
    </React.Fragment>
  );
}

export default CardWitTitle;